<template>
    <ul class="tree-ul">
        <tree-node v-for="(node,index) in options"
            :key="node.Id"
            :node ="node"
            :treeStore = "modelValue"
        ></tree-node>
    </ul>
</template>

<style>
    .tree-ul{
        list-style: none;
    }
</style>

<script>
    import treeNode from "./TreeNode.vue"
    export default{
        name:"tree",
        props:{
            modelValue: {
                type: [Array,Number],
                default: undefined,
            },
            singleSelect:{
                type:Boolean,
                default:function(){
                    return true;
                }
            },
            showCheckBox:{
                type:Boolean,
                default:function(){
                    return true;
                }
            },
            options:Array
        },
        provide:function(){
            return {
                singleSelect:this.singleSelect,
                showCheckBox:this.showCheckBox,
                selectNode:this.selectNode,
                removeNode:this.removeNode
            }
        },
        components:{
            'tree-node':treeNode
        },
        emits:[
            "update:modelValue"
        ],
        computed:{
            treeStore:{
                get() {
                    return this.modelValue;
                },
                // setter
                set(newValue) {
                    this.$emit("update:modelValue", newValue);
                }
            }
        },
        methods:{
            selectNode:function(value){
                if(this.singleSelect){
                    this.treeStore = value;
                }
                else{
                    this.treeStore.push(value);
                }
            },
            removeNode:function(value){
                if(this.singleSelect){
                    this.treeStore = null;
                }
                else{
                    let index = this.treeStore.findIndex(x=>x == value);
                    this.treeStore.splice(index,1)
                }
            }
        }
    }
</script>
